import {
    PurchasingContainer,
    PurchasingRegister,
} from '@Purchasing/Data/DataSource/Container'
import { CreatePurchaseProcessPayload } from '@Purchasing/Data/DataSource/API/Entity/PurchaseProcess'
import { PurchaseProcess } from '@Purchasing/Domain/Model/PurchaseProcess'
import { useCallback, useState } from 'react'

export const useCreatePurchaseProcess = () => {
    const useCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseCreatePurchaseProcess
    )
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    const create = useCallback(
        async (
            payload: CreatePurchaseProcessPayload
        ): Promise<PurchaseProcess | null> => {
            setLoading(true)
            setError(null)
            try {
                const result = await useCase.execute(payload)
                return result
            } catch (e: any) {
                console.error(e)
                setError(
                    e?.response?.data?.message ?? 'Erro ao criar o processo'
                )
                return null
            } finally {
                setLoading(false)
            }
        },
        [useCase]
    )

    return {
        create,
        loading,
        error,
    }
}
